import React, {Component} from 'react'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {gaPageView} from "../constants";
import i18n from "i18next";
import {NavLink} from "react-router-dom";

class Error extends Component {

    componentDidMount() {
        gaPageView()
    }

    render() {

        return (
            <>
                <section className="error-section pt-150">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12 text-center">
                                <div className="error-text">
                                    <h1>401</h1>
                                    <h2>Unauthorized Access</h2>
                                </div>
                                <div className="mt-20">
                                    <NavLink to="/console" className="custom-button">{i18n.t('go_to_console')}</NavLink>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </>
        )
    }
}

function mapStateToProps(state) {
    return {
        common: state.common
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Error);